var map = {
	"./img_additional_pos.svg": 65177,
	"./img_adentro.svg": 31803,
	"./img_aloha.svg": 83793,
	"./img_ansa.svg": 27443,
	"./img_athena.svg": 62144,
	"./img_attentive.svg": 43878,
	"./img_aurora_mysql.svg": 93301,
	"./img_aurora_postgresql.svg": 34585,
	"./img_big_query.svg": 69548,
	"./img_bikky.svg": 81462,
	"./img_bikky_bi.svg": 36294,
	"./img_bite.svg": 79806,
	"./img_black_box_intelligence.svg": 90340,
	"./img_brame.svg": 30799,
	"./img_braze.svg": 35207,
	"./img_cardfree.svg": 2251,
	"./img_cartwheel.svg": 73158,
	"./img_clickhouse.svg": 88782,
	"./img_custom_channels.svg": 85621,
	"./img_customerxi.svg": 62519,
	"./img_databricks.svg": 69562,
	"./img_delightable.png": 68381,
	"./img_deliverect.svg": 43915,
	"./img_deliverect_delivery.svg": 31997,
	"./img_doordash.svg": 38842,
	"./img_firebolt.svg": 19314,
	"./img_fishbowl.svg": 22573,
	"./img_flybuy.svg": 135,
	"./img_franpos.svg": 38016,
	"./img_genius_xenial.svg": 28869,
	"./img_gozone.svg": 36551,
	"./img_grubbrr.svg": 90361,
	"./img_guestxm.svg": 86769,
	"./img_ingest.svg": 43356,
	"./img_ingest_ai.svg": 68440,
	"./img_jotform.svg": 63662,
	"./img_klaviyo.svg": 25420,
	"./img_mariadb.svg": 81204,
	"./img_materialize.svg": 71154,
	"./img_momos.svg": 29426,
	"./img_mongodb.svg": 71805,
	"./img_mysql.svg": 61596,
	"./img_ncr.svg": 83156,
	"./img_olo.svg": 46288,
	"./img_olo_dispatch.svg": 75714,
	"./img_olo_engage.svg": 15383,
	"./img_olo_gdp.svg": 92905,
	"./img_olo_omnivore.svg": 36266,
	"./img_omnivore.svg": 84769,
	"./img_onosys.svg": 55639,
	"./img_open_tender.svg": 64328,
	"./img_oracle.svg": 76326,
	"./img_oracle_micros.svg": 67060,
	"./img_ovation.svg": 95382,
	"./img_par_brink.svg": 1632,
	"./img_par_brink_sku.svg": 98256,
	"./img_peek_poke.svg": 81150,
	"./img_pos_itouch.svg": 97304,
	"./img_postgresql.svg": 89480,
	"./img_qu.svg": 66899,
	"./img_rad.svg": 88130,
	"./img_redshift.svg": 36109,
	"./img_revel.svg": 96212,
	"./img_shift4.svg": 1932,
	"./img_singlestore.svg": 38860,
	"./img_snowflake.svg": 28430,
	"./img_sql_server.svg": 93195,
	"./img_square.svg": 14621,
	"./img_square_digital.svg": 26661,
	"./img_sunday.svg": 84973,
	"./img_tabit.svg": 63721,
	"./img_tattle.svg": 30357,
	"./img_thanx.svg": 76522,
	"./img_toast.svg": 1798,
	"./img_toast_kiosk.svg": 70449,
	"./img_uber.svg": 33473,
	"./img_union.svg": 39154,
	"./img_upn_go.svg": 94166,
	"./img_valutec.png": 23298,
	"./img_vromo.svg": 74519,
	"./img_yumpingo.svg": 80508,
	"assets/images/integrations/logos/img_additional_pos.svg": 65177,
	"assets/images/integrations/logos/img_adentro.svg": 31803,
	"assets/images/integrations/logos/img_aloha.svg": 83793,
	"assets/images/integrations/logos/img_ansa.svg": 27443,
	"assets/images/integrations/logos/img_athena.svg": 62144,
	"assets/images/integrations/logos/img_attentive.svg": 43878,
	"assets/images/integrations/logos/img_aurora_mysql.svg": 93301,
	"assets/images/integrations/logos/img_aurora_postgresql.svg": 34585,
	"assets/images/integrations/logos/img_big_query.svg": 69548,
	"assets/images/integrations/logos/img_bikky.svg": 81462,
	"assets/images/integrations/logos/img_bikky_bi.svg": 36294,
	"assets/images/integrations/logos/img_bite.svg": 79806,
	"assets/images/integrations/logos/img_black_box_intelligence.svg": 90340,
	"assets/images/integrations/logos/img_brame.svg": 30799,
	"assets/images/integrations/logos/img_braze.svg": 35207,
	"assets/images/integrations/logos/img_cardfree.svg": 2251,
	"assets/images/integrations/logos/img_cartwheel.svg": 73158,
	"assets/images/integrations/logos/img_clickhouse.svg": 88782,
	"assets/images/integrations/logos/img_custom_channels.svg": 85621,
	"assets/images/integrations/logos/img_customerxi.svg": 62519,
	"assets/images/integrations/logos/img_databricks.svg": 69562,
	"assets/images/integrations/logos/img_delightable.png": 68381,
	"assets/images/integrations/logos/img_deliverect.svg": 43915,
	"assets/images/integrations/logos/img_deliverect_delivery.svg": 31997,
	"assets/images/integrations/logos/img_doordash.svg": 38842,
	"assets/images/integrations/logos/img_firebolt.svg": 19314,
	"assets/images/integrations/logos/img_fishbowl.svg": 22573,
	"assets/images/integrations/logos/img_flybuy.svg": 135,
	"assets/images/integrations/logos/img_franpos.svg": 38016,
	"assets/images/integrations/logos/img_genius_xenial.svg": 28869,
	"assets/images/integrations/logos/img_gozone.svg": 36551,
	"assets/images/integrations/logos/img_grubbrr.svg": 90361,
	"assets/images/integrations/logos/img_guestxm.svg": 86769,
	"assets/images/integrations/logos/img_ingest.svg": 43356,
	"assets/images/integrations/logos/img_ingest_ai.svg": 68440,
	"assets/images/integrations/logos/img_jotform.svg": 63662,
	"assets/images/integrations/logos/img_klaviyo.svg": 25420,
	"assets/images/integrations/logos/img_mariadb.svg": 81204,
	"assets/images/integrations/logos/img_materialize.svg": 71154,
	"assets/images/integrations/logos/img_momos.svg": 29426,
	"assets/images/integrations/logos/img_mongodb.svg": 71805,
	"assets/images/integrations/logos/img_mysql.svg": 61596,
	"assets/images/integrations/logos/img_ncr.svg": 83156,
	"assets/images/integrations/logos/img_olo.svg": 46288,
	"assets/images/integrations/logos/img_olo_dispatch.svg": 75714,
	"assets/images/integrations/logos/img_olo_engage.svg": 15383,
	"assets/images/integrations/logos/img_olo_gdp.svg": 92905,
	"assets/images/integrations/logos/img_olo_omnivore.svg": 36266,
	"assets/images/integrations/logos/img_omnivore.svg": 84769,
	"assets/images/integrations/logos/img_onosys.svg": 55639,
	"assets/images/integrations/logos/img_open_tender.svg": 64328,
	"assets/images/integrations/logos/img_oracle.svg": 76326,
	"assets/images/integrations/logos/img_oracle_micros.svg": 67060,
	"assets/images/integrations/logos/img_ovation.svg": 95382,
	"assets/images/integrations/logos/img_par_brink.svg": 1632,
	"assets/images/integrations/logos/img_par_brink_sku.svg": 98256,
	"assets/images/integrations/logos/img_peek_poke.svg": 81150,
	"assets/images/integrations/logos/img_pos_itouch.svg": 97304,
	"assets/images/integrations/logos/img_postgresql.svg": 89480,
	"assets/images/integrations/logos/img_qu.svg": 66899,
	"assets/images/integrations/logos/img_rad.svg": 88130,
	"assets/images/integrations/logos/img_redshift.svg": 36109,
	"assets/images/integrations/logos/img_revel.svg": 96212,
	"assets/images/integrations/logos/img_shift4.svg": 1932,
	"assets/images/integrations/logos/img_singlestore.svg": 38860,
	"assets/images/integrations/logos/img_snowflake.svg": 28430,
	"assets/images/integrations/logos/img_sql_server.svg": 93195,
	"assets/images/integrations/logos/img_square.svg": 14621,
	"assets/images/integrations/logos/img_square_digital.svg": 26661,
	"assets/images/integrations/logos/img_sunday.svg": 84973,
	"assets/images/integrations/logos/img_tabit.svg": 63721,
	"assets/images/integrations/logos/img_tattle.svg": 30357,
	"assets/images/integrations/logos/img_thanx.svg": 76522,
	"assets/images/integrations/logos/img_toast.svg": 1798,
	"assets/images/integrations/logos/img_toast_kiosk.svg": 70449,
	"assets/images/integrations/logos/img_uber.svg": 33473,
	"assets/images/integrations/logos/img_union.svg": 39154,
	"assets/images/integrations/logos/img_upn_go.svg": 94166,
	"assets/images/integrations/logos/img_valutec.png": 23298,
	"assets/images/integrations/logos/img_vromo.svg": 74519,
	"assets/images/integrations/logos/img_yumpingo.svg": 80508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34197;